// extracted by mini-css-extract-plugin
module.exports = {"core":"Language-core-rIJ1b","drop":"Language-drop-lMXPU"};